module.exports = __webpack_public_path__ + "static/media/Group.cd1ded31.webp";